"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPage = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _Log = require("../../constants/Log");
var _DmsLog = require("../DmsLog/DmsLog");
var _DmsPermissions = require("../DmsPermissions/DmsPermissions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsPage Component
 *
 * This component serves as a wrapper for rendering pages with specific properties and functionalities.
 *
 * @param {React.ReactNode} props.children - The content to be rendered within the DmsPage component.
 * @param {string|null} [props.message=null] - The log message that will be displayed. The default is "User accessed the page {name}".
 * @param {string|null} [props.name=null] - The name of the page, which will be displayed as the module name in the log.
 * @param {Array} [props.permissions=[]] - An array of permissions required to access the page.
 * @example
 *
 * return (
 *   <DmsPage name="About">
 *     <h1>About Page</h1>
 *   </DmsPage>
 * );
 */
const DmsPage = _ref => {
  let {
    children = null,
    message = null,
    name = null,
    permissions = []
  } = _ref;
  const alreadyLogged = (0, _react.useRef)(false);
  (0, _react.useEffect)(() => {
    alreadyLogged.current = true;
  }, []);
  if (!name) {
    throw new Error(_reactIntlUniversal.default.get("Pagenameisrequired").d("Page name is required"));
  }
  if (!message) {
    message = _reactIntlUniversal.default.get("Useracessedthepagename").d("User acessed the page {name}");
    message = message.replace("{name}", name);
  }
  return /*#__PURE__*/_react.default.createElement(_DmsPermissions.DmsPermissions, {
    permissions: permissions
  }, alreadyLogged.current || /*#__PURE__*/_react.default.createElement(_DmsLog.DmsLog, {
    message: message,
    module: name,
    level: _Log.LogLevel.INFO,
    type: _Log.LogType.USER
  }), children);
};
exports.DmsPage = DmsPage;